<template>
  <div class="outterBox">
    <div class="">
      <!--      <h2 v-if="showTitle">추천메뉴 & 프로모션ㅁㅁㅁ</h2>-->
      <SlideCarousels
        v-show="true"
        :item-total-count="items.length"
        :items="items"
        :breakpoints="breakpoints"
        :slide-number="3"
        fixed-height="440px"
        :gap="3"
      >
        <template v-slot:slides>
          <VueperSlide v-for="item in items" :key="item.id">
            <template #content>
              <div ref="top">
                <DiningPromotionItem :item="item" @ImgLoaded="refreshHeight" />
              </div>
            </template>
          </VueperSlide>
        </template>
      </SlideCarousels>
    </div>
  </div>
</template>

<script>
import SlideCarousels from '@/components/SlideCarousels';
import {VueperSlide} from 'vueperslides';
import DiningPromotionItem from '@/pages/MainPage/Components/DiningPromotionItem';
import boardService, {BoardParam} from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import moment from 'moment';
import {BoardArticle} from '@/models';
import {RESTAURANT_BOARD_ID} from './DiningPromotionBoardId';
export default {
  props: {
    showSignatureMode: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  components: {SlideCarousels, VueperSlide, DiningPromotionItem},
  data() {
    return {
      windowWidth: 0,
      fixedHeight: '500px',
      items: [],
      breakpoints: {
        1200: {
          fixedHeight: '440px',
          bullets: false,
          arrows: false,
          visibleSlides: 3,
          touchable: false,
          disableArrowsOnEdges: true,
        },
        992: {
          fixedHeight: '600px',
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: false,
          disableArrowsOnEdges: true,
        },
        768: {
          fixedHeight: '550px',
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: false,
          disableArrowsOnEdges: true,
        },
      },
    };
  },
  async created() {
    // {
    //   id: 0,
    //   image: require('@/assets/images/Golf/main_dining_image01.jpg'),
    //   title: '공룡알과 먹돌',
    //   price: 33000,
    //   type: 'SIGNATURE MENU',
    //   typeCode: 0,
    //   startDate: '2021.10.01',
    //   endDate: '2021.12.31',
    // },

    let p = new BoardParam(RESTAURANT_BOARD_ID);
    p.subtitle1Search = this.showSignatureMode ? 'SIGNATURE MENU' : null;
    p.sortField = 'sortIdx';
    p.sortAscDesc = 'asc';
    const aList = await boardService.getArticleListObjParam(p);

    console.log(aList);

    this.items = aList.map(x => {
      let item = {
        id: x.id,
        type: x.subtitle1,
        title: x.title,
        menu: x.subtitle2,
        time: x.subtitle4,
        price: x.subtitle5,
        desc: x.memo,
        thumbnail: x.getFirstAttachFileUrl(true),
        image: x.getFirstAttachFileUrl(true),
      };

      return item;
    });

    // this.items = [];

    this.$nextTick(() => {
      this.refreshHeight();
    });
  },
  watch: {
    windowWidth(newHeight, oldHeight) {
      this.refreshHeight();
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.refreshHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    refreshHeight() {
      this.$nextTick(() => {
        console.log('==========', this.$refs.top);
        if (this.$refs.top !== undefined) {
          let px = this.$refs.top[0].clientHeight;
          this.fixedHeight = `${px + 20}px`;
          console.log('HEIGHT>>>!!!1', this.fixedHeight);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
h2 {
  padding-top: 3rem;
  padding-bottom: 0rem;
  height: 3rem;
  text-align: center;
  //color: #222222;
  color: #222222;
  //font-family: 'Nanum Gothic', sans-serif;
  font-family: 'Jeju Myeongjo', sans-serif;
  font-weight: 700;
  //font-size: 1.6em !important;
}

.outterBox {
  //background-color: #261414;
  //margin-bottom: 3rem;
  //border-top: 1px solid #eaeaea;
}
</style>
